import Vue from 'vue'
import api from "../../api/api";
import {find, orderBy, pickBy, sumBy, forEach, filter, includes, isEmpty} from "lodash";

const getDefaultState = () => {
    return {
        items: [],
        updatedAt: null,
        loaded: false,
        sortBy: 'code',
        sortByDirection: 'asc',
        searchBy: '',
        filter: null,
        filterByCard: null,
        filterByStatuses: [],
        statusFilterOptions: {},
        filterOptions: [
            {
                id: 'all',
                title: 'All',
                data: {
                    searchBy: '',
                    filterByCard: null,
                    filterByStatuses: [],
                }
            },
            {
                id: 'active',
                title: 'Active',
                data: {
                    searchBy: '',
                    filterByCard: null,
                    filterByStatuses: [1, 2, 3, 5, 8],
                }
            },
            {
                id: 'wrong',
                title: 'Wrong',
                data: {
                    searchBy: '',
                    filterByCard: null,
                    filterByStatuses: [2, 3, 5, 8],
                }
            },
            {
                id: 'offline',
                title: 'Offline',
                data: {
                    searchBy: '',
                    filterByCard: null,
                    filterByStatuses: [6, 7, 9, 10],
                }
            },
        ],
    }
};

const state = getDefaultState();

const getters = {
    isLoaded(state) {
        return state.loaded;
    },
    byId: (state) => (id) => {
        return find(state.items, {id: parseInt(id)});
    },
    list(state) {
        let items = state.items;

        if (!isEmpty(state.filterByStatuses)) {
            items = pickBy(items, function (item) {
                return includes(state.filterByStatuses, item.status_id);
            })
        }

        if (state.filterByCard) {
            items = pickBy(items, function (item) {
                if (item.gpus[0] === undefined)
                    return false;
                return item.gpus[0].id === parseInt(state.filterByCard)
            })
        }

        if (state.searchBy) {
            items = pickBy(items, function (item) {
                return item.code.substring(0, state.searchBy.length) === state.searchBy
            })
        }

        return orderBy(items, state.sortBy, [state.sortByDirection]);
    },
    statuses(state, getters, rootState) {
        let items = getters.list;
        let statuses = rootState.statuses.items;
        let result = {};

        let allHashRate = sumBy(items, function (o) {
            return o.hash_rate;
        });

        let allExceptedhashRate = sumBy(items, function (o) {
            return o.excepted_hash_rate;
        });

        result[0] = {
            id: 0,
            name: 'Sum',
            quantity: items.length,
            hash_rate: allHashRate,
            excepted_hash_rate: allExceptedhashRate,
            percent: allHashRate > 0 ? Math.round((allHashRate / allExceptedhashRate) * 100) : 0,
        };

        forEach(statuses, function (status) {
            let statusItems = filter(items, {status_id: parseInt(status.id)});

            let hashRate = sumBy(statusItems, function (o) {
                return o.hash_rate;
            });

            let exceptedHashRate = sumBy(statusItems, function (o) {
                return o.excepted_hash_rate;
            });

            result[status.id] = {
                id: parseInt(status.id),
                name: status.name,
                quantity: statusItems.length,
                hash_rate: hashRate,
                excepted_hash_rate: exceptedHashRate,
                percent: hashRate > 0 ? Math.round((hashRate / exceptedHashRate) * 100) : 0,
            };
        });
        return result;
    }
};

const actions = {
    load({dispatch}) {
        return new Promise((resolve) => {
            api.get('/monitor').then((result) => {
                dispatch('set', result);
                resolve();
            });
        })
    },
    async set({commit}, payload) {
        commit('statuses/set', payload.statuses, {root: true});
        commit('currencies/set', payload.currencies, {root: true});
        commit('gpus/set', payload.gpus, {root: true});
        commit('cards/set', payload.cards, {root: true});
        commit("set", payload.computers);
        commit("setUpdatedAt", new Date(payload.date * 1000));
    },
    setFilter({commit, state}, key) {
        if (key) {
            let data = find(state.filterOptions, {id: key}).data;
            commit('setFilter', key);
            commit('setSearchBy', data.searchBy);
            commit('setFilterByCard', data.filterByCard);
            commit('setFilterByStatuses', data.filterByStatuses);
            Vue.nextTick(function () {
                commit('setFilter', null);
            });
        }
    }
};

const mutations = {
    set(state, payload) {
        state.items = payload;
    },
    setUpdatedAt(state, payload) {
        state.updatedAt = payload;
        if (state.loaded === false)
            state.loaded = true;
    },
    setSortBy(state, value) {
        state.sortBy = value;
    },
    setSearchBy(state, value) {
        state.searchBy = value;
        Vue.nextTick(function () {
            state.filter = null;
        });
    },
    setFilterByStatuses(state, value) {
        if (includes(value, 0)) {
            state.filterByStatuses = [];
        } else {
            state.filterByStatuses = value;
        }
        Vue.nextTick(function () {
            state.filter = null;
        });
    },
    setStatusId(state, payload) {
        find(state.items, {id: parseInt(payload.id)}).status_id = payload.status_id;
    },
    setFilterByCard(state, value) {
        state.filterByCard = value;
        state.filter = null;
    },
    setFilter(state, value) {
        state.filter = value;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
